//tipos
import { GetterTree } from "vuex";
import { State } from "@/typings/store";
import { StateClientes } from "@/typings/store/plugins/easyFirestore/clientes";

const getters: GetterTree<StateClientes, State> = {
    get(state) {
        return state.all;
    },
    getArray(state) {
        return Object.values(state.all);
    },
};

const clientes = {
    firestorePath: "dev/v1/clientes",
    firestoreRefType: "collection",
    moduleName: "clientes",
    statePropName: "all",
    namespaced: true,
    serverChange: {
        convertTimestamps: {
            created_at: "%convertTimestamp%", // default
            updated_at: "%convertTimestamp%", // default
        },
    },
    state: {},
    getters,
    mutations: {},
    actions: {},
};

export default clientes;
